import {
  ReplaceSettingsViewDataPayload,
  UpdateSettingsViewDataPayload,
} from 'src/client/appTypings';
import { createAction } from '@reduxjs/toolkit';

export const replaceSettingsViewDataAction =
  createAction<ReplaceSettingsViewDataPayload>('settings/replaceSettingsView');

export const updateSettingsViewDataAction =
  createAction<UpdateSettingsViewDataPayload>('settings/updateSettingsView');
